function isTouchSupported(): boolean {
  return !!('ontouchstart' in window);
}

export default isTouchSupported;
